import React from 'react'
import PropTypes from 'prop-types'
import { useWindowWidth } from './MPGridUtils'

function MPGridRow (props) {
  /*
    * Empty 'width' will cause it to render to the width of its parent
    * Optionally MPGridColumn can wrap multiple MPGridRow's to control the width
    * Respect the constrained PropTypes of width and alignItems
  */

  const rowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    height: '100%',
    width: '100%',
    flexDirection: 'row'
  }

  const alignItemsStyle = props.alignItems ? { alignItems: `${props.alignItems}` } : ''
  const justifyContentStyle = props.justifyContent ? { justifyContent: `${props.justifyContent}` } : ''
  const inheritedStyles = props.style ? props.style : ''
  let widthStyle = ''

  if (useWindowWidth() >= 1060 && props.width) {
    widthStyle = {
      maxWidth: (props.width * 80 + (props.width - 1) * 60)
    }
  }

  return (
    <div id={props.id} style={{ ...rowStyle, ...widthStyle, ...alignItemsStyle, ...justifyContentStyle, ...inheritedStyles }}>
      {props.children}
    </div>
  )
}

MPGridRow.propTypes = {
  width: PropTypes.oneOf([2, 3, 4, 5, 6, 8]),
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  justifyContent: PropTypes.oneOf(['space-between']),
  style: PropTypes.object,
  children: PropTypes.node,
  id: PropTypes.string
}

export default MPGridRow
